import { Display } from "../../../Models/Display";

export const getCustomDatasHeaderGridLayout = () => ({
  columns: "0.35fr 1fr 1fr 1fr 1fr 1fr 1fr",
  areas: ` 
      ". description unitWeight unitPrice hsCode countryIsoCode2 quantity "
    `,
});

export const getCustomDatasListItemGridLayout = (display: Display) => ({
  columns: display.xs
    ? " 1fr "
    : display.sm
      ? " 1fr 1fr "
      : display.md
        ? " 1fr 1fr 1fr "
        : " 0.35fr 1fr 1fr 1fr 1fr 1fr 1fr ",
  areas: display.xs
    ? `
      " icon "
      " description "
      " unitWeight "
      " unitPrice "
      " hsCode "
      " countryIsoCode2 "
      " quantity "
    `
    : display.sm
      ? `
      " icon icon"
      " description unitWeight"
      " unitPrice hsCode"
      " countryIsoCode2 quantity"
    `
      : display.md
        ? `
      " icon icon icon "  
      " description unitWeight unitPrice "
      " hsCode countryIsoCode2 quantity "
    `
        : `
      " icon description unitWeight unitPrice hsCode countryIsoCode2 quantity "
    `,
});

export const getCustomDatasFooterGridLayout = (display: Display) => ({
  columns: display.xs
    ? "1fr"
    : display.sm
      ? "1fr 1fr"
      : display.md
        ? "1fr 1fr 1fr"
        : "2fr 1fr 1fr 1fr 1fr 1fr",

  areas: display.xs
    ? `
      "totalQuantity"
      "totalWeight"
      "totalVolume"
    `
    : display.sm
      ? `
      "totalQuantity totalQuantity"
      "totalWeight totalVolume"
    `
      : display.md
        ? `
      "totalQuantity totalWeight totalVolume"
    `
        : `
      ". . . totalQuantity totalWeight totalVolume"
    `,
});
